import React, { Fragment } from "react";
import { Link, Text } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import styles from "./BaggagePolicies.module.css";
import Frame from "../Frame/index.js";
const BaggagePolicies = ({ baggagePolicies, customTitle }) => {
    const i18n = useI18n();
    if (baggagePolicies.length === 0) {
        return null;
    }
    const defaultTitle = baggagePolicies.length === 1 ? t("flights_sr_baggage_policy_list_1") : t("flights_sr_baggage_policies_list");
    return (React.createElement(Frame, { pt: 1 },
        React.createElement(Text, { variant: "small_1", className: styles.title }, customTitle || i18n.trans(defaultTitle)),
        baggagePolicies.map((policy, i) => {
            let separator = "";
            const isLastOne = i === baggagePolicies.length - 1;
            if (!isLastOne && baggagePolicies.length > 1) {
                const isSecondToLastOne = i === baggagePolicies.length - 2;
                separator = i18n.trans(isSecondToLastOne ? t("flights_sr_airline_separator_last") : t("flights_sr_airline_separator"));
            }
            return (React.createElement(Fragment, { key: policy.name + policy.url + i },
                React.createElement(Link, { className: styles.itemLink, text: policy.name, href: policy.url, attributes: {
                        target: "_blank",
                        rel: "noopener noreferrer",
                        "aria-label": i18n.trans(t("a11y_flights_sr_baggage_policy_link_hint", { variables: { airline_name: policy.name } }))
                    } }),
                separator));
        })));
};
export default BaggagePolicies;
